import { render, staticRenderFns } from "./BagsPage.vue?vue&type=template&id=3bcea1d9&scoped=true"
import script from "./BagsPage.vue?vue&type=script&lang=js"
export * from "./BagsPage.vue?vue&type=script&lang=js"
import style0 from "./BagsPage.vue?vue&type=style&index=0&id=3bcea1d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcea1d9",
  null
  
)

export default component.exports